import { makerCheckerInstance } from "../axios/axiosInstance";

export const getEntities = async () => {
    const url = `/RoleEntity/Application?appId=13`
    const response = await makerCheckerInstance.get(url)
    return response
}